var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11978",
    "data-name": "Group 11978",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.463,
    height: 20.579,
    viewBox: "0 0 14.463 20.579",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11615",
    "data-name": "Path 11615",
    d: "M2248.553-262.714c0,.015.009.03.013.045.2.171.172.41.173.633.007,1.618,0,3.236,0,4.854q0,2.73,0,5.46a1.813,1.813,0,0,1-.06.674.4.4,0,0,1-.064.125.635.635,0,0,1-.574.1q-3.123-.622-6.246-1.248a.711.711,0,0,1-.447-.257,1.049,1.049,0,0,1,.213-.784q3-4.5,5.995-8.995A1.269,1.269,0,0,1,2248.553-262.714Z",
    transform: "translate(-2241.337 262.714)",
    fill: "#bae4ef"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11616",
    "data-name": "Path 11616",
    d: "M2318.15-161.682a1.056,1.056,0,0,1-.222.669q-2.974,4.46-5.949,8.919a1.08,1.08,0,0,1-.824.6h-.226a.532.532,0,0,1-.175-.479q-.015-3.929,0-7.858a.519.519,0,0,1,.175-.477h0a.783.783,0,0,1,.537-.244q2.986-.6,5.972-1.192C2317.673-161.789,2317.933-161.919,2318.15-161.682Z",
    transform: "translate(-2303.695 172.07)",
    fill: "#10b3ec"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11617",
    "data-name": "Path 11617",
    d: "M2248.646-159.117v8.814a1.054,1.054,0,0,1-.986-.527q-3.024-4.529-6.043-9.063a.885.885,0,0,1-.191-.6c1.624.319,3.247.647,4.873.955A19.692,19.692,0,0,0,2248.646-159.117Z",
    transform: "translate(-2241.412 170.88)",
    fill: "#73cce3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11618",
    "data-name": "Path 11618",
    d: "M2319.732-251.984c-1.376.269-2.751.546-4.129.8-1.03.192-2.045.465-3.091.572q0-5.859,0-11.718a1.086,1.086,0,0,1,1.048.617q2.409,3.618,4.822,7.234c.379.569.756,1.139,1.138,1.706A1.121,1.121,0,0,1,2319.732-251.984Z",
    transform: "translate(-2305.277 262.371)",
    fill: "#73cce3"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.4eceb7d76b6dfa653e085ea47bd186af.svg";
export { ForwardRef as ReactComponent };